<template>
	<div style="position: relative" :style="{width: windowInnerWidth, height: windowInnerHeight}">
		<div style="text-align: center" id="three">

		</div>

		<div v-if="titleViewVisible === true"
			:class="loadingPercent < 100 ? 'title-view loading-background' : 'title-view loading-background-complete'">
			<div
				style="text-align: center; width: 100%; height: 100%; display: flex; font-size: 24px; font-weight: 600;justify-content: center;align-items: center;">
				<div>
					<img src="../assets/shopopee.png" style="width: 300px; height: 300px;user-select:none;"
						onerror="this.error = null">
					<br>

					<span style="user-select:none;">
						<span class="shoppee_text_3">3</span><span class="shoppee_text_D">D</span><span
							style="color: #b20bff;font-size: 2em;">Shop</span><span
							style="color: #17a5ff;font-size: 2em;">opee</span> 商城</span>

					<div class="loadingPercent < 100 ? 'loading-num-part num-part-uncomplete' : 'loading-num-part num-part-complete'"
						style="margin:4em">

						<div style="position: relative;" v-show="loadingPercent < 100">
							<div class="loading_ring">
								<span style="user-select:none;color: #fff;">{{loadingPercent}}%</span>
								<span class="loading_ring_span"></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="titleViewVisible === false&&isAnimation=== false" class="title-view">

			<div
				style="text-align: center; width: 100%;  display: flex; font-size: 24px; font-weight: 600;justify-content: center;align-items: center;position: fixed;bottom: 0;">

				<div>
					<div @click="clickTitleStart" class="loading-num-part num-part-complete" style="margin-bottom:5em">

						<div class="btn_start_div" style="width: 100%;height: 100%; position:relative;">
							<span class="btn_start"></span>
							<div style="height: 100%;padding-top: 35%;"><span>出發</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="my-msg-box" v-show="titleViewVisible === false&&chatVisible === true">
			<ul class="msg-box">
				<li class="title-box">

				</li>

				<li class="content-box">
					首個香港 3D 商城, 帶給你一個全新 3D 購物體驗!
				</li>

				<li>
					<div class="operation-box">
						<span>...</span>
					</div>
				</li>
			</ul>
		</div>
	</div>

</template>

<script setup>
import {
  getCurrentInstance,
  onBeforeUnmount,
  onMounted,
  ref,
  toRef,
  provide, watch
} from 'vue'
	

	import {
		GUI
	} from 'dat.gui';
	import {
		clone
	} from 'three/examples/jsm/utils/SkeletonUtils';

	import {
		FBXLoader
	} from 'three/examples/jsm/loaders/FBXLoader';
	import * as TWEEN from '@tweenjs/tween.js'
  const props = defineProps(['parentWidth','parentHeight','typeInser'])
  const emits = defineEmits(['goCallbackMain'])


	let {
		proxy
	} = getCurrentInstance();
	let THREE = proxy.$THREE;
	var width = ref(window.innerWidth-16)
  var height = ref(window.innerHeight-16)
	const windowInnerWidth = ref((window.innerWidth-16) + "px")
	const windowInnerHeight = ref((window.innerHeight)-16 + "px")

	// const isMobile = ('ontouchstart' in document.documentElement)


	const clock = new THREE.Clock();
	const FPS = 30; // 指的是 30帧每秒的情况
	const singleFrameTime = (1 / FPS);
	let timeStamp = 0
	// let currTimeStamp = 0
	let mixerUpdateDelta;

	//每次渲染要執行的邏輯方法列表
	let funcListObj = {}
	//是否显示标题界面
	const titleViewVisible = ref(true)

	//是否显示标题界面
	const isAnimation = ref(false)

  const typeInser = ref(false)
	let tpHeliObj = null

	//加载百分比
	let loadingPercent = ref(30)
	// //提示文字
	// let confirmText = ref("")
	// //是否提示可见
	// let confirmVisible = ref(false)

	let chatVisible = ref(true)


	//是否开始渲染
	let renderFlag = true


	//动画对象
	const animationObjGroup = {}

	//贴图map
	const textureMap = {}

	// //需要加载的贴图list
	// const textureNameList = [
	// 	"outfit-classic-03-v2-m-bottom-D.jpg",
	// 	"outfit-classic-03-v2-m-bottom-D_B.jpg",
	// 	"outfit-classic-03-v2-m-bottom-D_G.jpg",
	// 	"outfit-classic-03-v2-m-bottom-D_W.jpg",
	// 	"outfit-classic-03-v2-m-top-D.jpg",
	// 	"outfit-classic-03-v2-m-top-D_B.jpg",
	// 	"outfit-classic-03-v2-m-top-D_W.jpg",
	// 	"outfit-classic-03-v2-m-top-D_G.jpg",
	// ]
	// 3D场景对象Scene
	let scene
	//渲染器
	let render
	//2D標籤渲染器
	// let label2DRenderer
	//3D標籤渲染器
	// let label3DRenderer
	//摄像机
	let camera
	//天空盒攝像機
	let cubeCamera

	// //全局环境贴图
	// let sceneEnvironmentMap

	// const gltfLoader = new GLTFLoader();
	const fbxLoader = new FBXLoader();
	//动作列表
	const mixerObj = {

	}

	//加载过的物件
	const loadObj = {}

	//环境光
	let ambient = new THREE.AmbientLight(0xffffff, 1.5);


	function clickTitleStart() {
		isAnimation.value = true
		chatVisible.value = false
		const tween_2 = new TWEEN.Tween(camera.position)
			.to({
				z: -35,
			}, 1500)
			.start()
			// .easing(TWEEN.Easing.Sinusoidal.In)
			.onComplete(() => {
				delete animationObjGroup["camera_position_1"]
        if (typeInser.value ===true) {
          emits("goCallbackMain")
        }else {
            try {
              window.parent.location.href = process.env.NODE_ENV === 'production' ?proxy.$ShopopeeUrl+"3d/index": "http://192.168.3.9:8081/";
            } catch (e) {
              //TODO handle the exception
              window.location.href = process.env.NODE_ENV === 'production' ?proxy.$ShopopeeUrl+"3d/index": "http://192.168.3.9:8081/";
            }
        }
				// chatVisible.value = true
				// camera.position.set(72, 2.5, 10);
			})

		animationObjGroup["camera_position_1"] = tween_2


	}
	window.onresize = function() {
		// 重置渲染器输出画布canvas尺寸
		render.setSize(width.value-16, height.value-16);
		// label2DRenderer.setSize(window.innerWidth, window.innerHeight)
		// label3DRenderer.setSize(window.innerWidth, window.innerHeight)
		// 全屏情况下：设置观察范围长宽比aspect为窗口宽高比
		camera.aspect = (width.value-16) / (height.value-16);
		// 渲染器执行render方法的时候会读取相机对象的投影矩阵属性projectionMatrix
		// 但是不会每渲染一帧，就通过相机的属性计算投影矩阵(节约计算资源)
		// 如果相机的一些属性发生了变化，需要执行updateProjectionMatrix ()方法更新相机的投影矩阵
		camera.updateProjectionMatrix();
	};


	//更新播放动作方法
	function updateMixerByTime() {
		//播放动画
		for (let i in mixerObj) {
			mixerObj[i].update(mixerUpdateDelta);
		}
	}

	function initValue() {
		scene = new THREE.Scene()
		camera = new THREE.PerspectiveCamera(45, 8.0 / 5.0, 1, 600)
		camera.aspect = (width.value) / (height.value);
		camera.updateProjectionMatrix();
		camera.position.set(72.5, 2.5, -30);
		render = new THREE.WebGLRenderer({
			// logarithmicDepthBuffer: true, // 设置对数深度缓冲区，优化深度冲突问题
			antialias: true, //开启抗锯齿,
			alpha: true,
			precision: 'mediump',
			powerPreference: "high-performance",
		})

		render.gammaInput = true;
		render.gammaOutput = true; //inear转gamma
		render.toneMapping = THREE.ACESFilmicToneMapping
		render.useLegacyLights = true

		render.setPixelRatio(window.devicePixelRatio); //设置屏幕像素比
		// render.setPixelRatio(2); //设置屏幕像素比
		render.setClearColor(0x000000, 1); //设置背景色


		funcListObj['updateTween'] = updateTween
		//創建島
		createIsland()
		//
		createGuideShopman(80, -10)

		//     let gui = new GUI()
		//     gui.add(camera.rotation, "x").step(0.01)
		//     gui.add(camera.rotation, "y").step(0.01)
		//     gui.add(camera.rotation, "z").step(0.01)


		// 	let gui2 = new GUI()
		// 	gui2.add(camera.position, "x")
		// 	gui2.add(camera.position, "y")
		// 	gui2.add(camera.position, "z")

		//添加camera
		scene.add(camera);
		//添加环境光
		scene.add(ambient);

		//加載天空盒
		const cubeRenderTarget = new THREE.WebGLCubeRenderTarget(256);
		cubeCamera = new THREE.CubeCamera(0.1, 1000, cubeRenderTarget)

		let environmentMap = new THREE.CubeTextureLoader().load([
			process.env.BASE_URL + "mytextures/cube/Daylight_Box_Back.bmp",
			process.env.BASE_URL + "mytextures/cube/Daylight_Box_Front.bmp",
			process.env.BASE_URL + "mytextures/cube/Daylight_Box_Top.bmp",
			process.env.BASE_URL + "mytextures/cube/Daylight_Box_Bottom.bmp",
			process.env.BASE_URL + "mytextures/cube/Daylight_Box_Right.bmp",
			process.env.BASE_URL + "mytextures/cube/Daylight_Box_Left.bmp"
		], function(cubeTexture) {

			// sceneEnvironmentMap = environmentMap
			scene.background = cubeTexture;

			cubeCamera.update(render, scene);

		});
		render.setSize(width.value, height.value);
		render.shadowMap.enabled = true //渲染器開啟陰影渲染
		render.shadowMap.type = THREE.PCFSoftShadowMap;
		render.render(scene, camera);

		document.getElementById("three").innerHTML = ""
		document.getElementById("three").appendChild(render.domElement);

	}
    watch(() => props.parentHeight, (newValue, oldValue) => {
      try {
        windowInnerWidth.value =  props.parentWidth + "px"
        windowInnerHeight.value =  props.parentHeight+ "px"
        width.value =  Number(props.parentWidth)
        height.value =  Number(props.parentHeight)
        typeInser.value = props.typeInser
      }catch (e) {}

      initValue()
    })
	onMounted(() => {
    typeInser.value = props.typeInser
    if(typeInser.value === false){

      initValue()
    }

	})


	function updateTween() {
		for (let i in animationObjGroup) {
			animationObjGroup[i].update()
		}
	}


	//創建島
	function createIsland() {
		loadFbxModel("island/bannerland.fbx", {
			// positionX: -12,
			positionY: 0,
			// positionZ: -30,
			// scaleY: 50,
			loadCallback: (model) => {
				// console.log(model)
				model.traverse((object) => {
					if (object.isMesh) {
						object.castShadow = true;
					}
					if (object.name === "Small_Heli02") {
						tpHeliObj = object
					}
				})

				model.scale.multiply(new THREE.Vector3(0.01, 0.01, 0.01));
				loadingPercent.value += 5

			},
			callback: (group) => {
				scene.add(group)
				tpAnimation()
				renderFrame()

			}
		})

		loadFbxModel("island/Asset_tree3.fbx", {
			scaleY: 8,
			loadCallback: (model) => {
				const withAIObj = getEmptyWithAIObj()

				const mixer = new THREE.AnimationMixer(model);
				mixerObj[model.uuid] = mixer

				withAIObj.allActions = {};

				let animations = model.animations;

				//遍歷所有動作
				for (let i = 0; i !== animations.length; ++i) {
					//動作
					const clip = animations[i];
					const action = mixer.clipAction(clip);
					withAIObj.allActions[clip.name] = action;

				}

				withAIObj.activeAction = withAIObj.allActions['palmTreeAction'];
				withAIObj.activeAction.play();

			},
			callback: (group) => {
				scene.add(group)
				// console.log(group)
				group.position.x = 65
				group.position.z = -70
			}
		})
		loadFbxModel("island/Asset_tree3.fbx", {
			scaleY: 8,
			loadCallback: (model) => {
				const withAIObj = getEmptyWithAIObj()

				const mixer = new THREE.AnimationMixer(model);
				mixerObj[model.uuid] = mixer

				withAIObj.allActions = {};

				let animations = model.animations;

				//遍歷所有動作
				for (let i = 0; i !== animations.length; ++i) {
					//動作
					const clip = animations[i];
					const action = mixer.clipAction(clip);
					withAIObj.allActions[clip.name] = action;

				}

				withAIObj.activeAction = withAIObj.allActions['palmTreeAction'];
				withAIObj.activeAction.play();

			},
			callback: (group) => {
				scene.add(group)
				group.position.x = 55
				group.position.z = -70
			}
		})
	}

	//加載模型fbx
	function loadFbxModel(modelName, option = {}) {
		let optionObj = {
			positionX: 0,
			positionY: 0,
			positionZ: 0,
			scaleY: 0,
			rotateX: 0,
			rotateY: 0,
			rotateZ: 0,
			castShadow: false,
			receiveShadow: false,
			//加载模型成功后的回调
			loadCallback: null,
			//执行结束后的回调
			callback: null,
			//是否缓存加载的模型
			cache: true
		}

		optionObj = Object.assign(optionObj, option);

		const ObjGroup = new THREE.Group()

		//如果在缓存中没有该模型,加载模型
		if (null == loadObj[modelName]) {
			//同步加载，避免出现同时加载多个时null
			const promiseHander = new Promise((resolve, reject) => {
				fbxLoader.load(process.env.BASE_URL + `mymodels/fbx/${modelName}?r=${proxy.$versionNum}`, function(
					model) {
					if (optionObj.cache) {
						loadObj[modelName] = model
						// model = model.clone()
						model = clone(model)
					}

					optionObj["format"] = "fbx"

					handleModel(model, optionObj)

					ObjGroup.add(model)

					if (typeof optionObj.loadCallback === "function") {
						optionObj.loadCallback(model)
					}

					ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

					if (typeof optionObj.callback === "function") {
						optionObj.callback(ObjGroup)
					}

					return ObjGroup

				})
			})

		} else {
			//如果缓存中有此模型，克隆该模型
			// let model = loadObj[modelName].clone()
			let model = clone(loadObj[modelName])

			optionObj["format"] = "fbx"

			handleModel(model, optionObj)

			ObjGroup.add(model)

			if (typeof optionObj.loadCallback === "function") {
				optionObj.loadCallback(model)
			}

			ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

			if (typeof optionObj.callback === "function") {
				optionObj.callback(ObjGroup)
			}

			return ObjGroup
		}

	}



	function tpAnimation() {
		const tween_1 = new TWEEN.Tween(tpHeliObj.position)
			.to({
				x: -5000
			}, 8000)
			.start()
			// .easing(TWEEN.Easing.Sinusoidal.In)
			.onComplete(() => {
				delete animationObjGroup[tpHeliObj.uuid]

			})
		tween_1.repeat(Infinity)
		animationObjGroup[tpHeliObj.uuid] = tween_1
		tpAnimation2()
	}

	function tpAnimation2() {
		const tween_2 = new TWEEN.Tween(tpHeliObj.position)
			.to({
				y: 2500
			}, 1000)
			.start()
			// .easing(TWEEN.Easing.Sinusoidal.In)
			.onComplete(() => {
				tpHeliObj.position.y = 2500
				delete animationObjGroup[tpHeliObj.uuid + 1]
				tpAnimation3()
			})
		// tween_2.repeat(10)
		animationObjGroup[tpHeliObj.uuid + 1] = tween_2
	}

	function tpAnimation3() {
		const tween_2 = new TWEEN.Tween(tpHeliObj.position)
			.to({
				y: 3000
			}, 1000)
			.start()
			// .easing(TWEEN.Easing.Sinusoidal.In)
			.onComplete(() => {
				tpHeliObj.position.y = 3000
				delete animationObjGroup[tpHeliObj.uuid + 1]
				tpAnimation2()
			})
		// tween_2.repeat(Infinity)
		animationObjGroup[tpHeliObj.uuid + 1] = tween_2
	}





	//根据传入的参数调整模型
	function handleModel(model, optionObj) {
		let box3 = new THREE.Box3()
		let obj = new THREE.Vector3()
		let scaleNum
		box3.setFromObject(model)
		box3.getSize(obj)

		// if (optionObj.castShadow || optionObj.receiveShadow){
		model.traverse(function(object) {
			if (object.isMesh) {
				// if (optionObj.castShadow ){
				object.castShadow = true;
				// }

				// if (optionObj.receiveShadow ){
				object.receiveShadow = true;
				// }

				if (optionObj.format === "fbx") {
					object.material.emissive = new THREE.Color(1, 1, 1);
					object.material.emissiveIntensity = 1;
					object.material.emissiveMap = object.material.map;
				}

			}
		});
		// }

		if (optionObj.rotateX > 0) {
			model.rotation.x = optionObj.rotateX
		}

		if (optionObj.rotateY > 0) {
			model.rotation.y = optionObj.rotateY
		}

		if (optionObj.rotateZ > 0) {
			model.rotation.z = optionObj.rotateZ
		}

		if (optionObj.scaleY > 0) {
			scaleNum = optionObj.scaleY / obj.getComponent(1)
			let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
			model.scale.multiply(vector);
		}


		return model
	}

	//界面刷新
	function renderFrame() {
		// stats.update();
		mixerUpdateDelta = clock.getDelta()

		if (loadingPercent.value > 39 && loadingPercent.value < 100) {
			loadingPercent.value += 1
		} else if (loadingPercent.value == 100) {
			// controlFlag = true

			titleViewVisible.value = true
			loadingPercent.value += 1
			setTimeout(() => {
				getSceneModelFaceNum(scene)
			}, 5000)

		}


		if (renderFlag) {
			for (const v in funcListObj) {
				if (typeof funcListObj[v] === "function") {
					funcListObj[v]()
				}
			}
		}

		timeStamp += mixerUpdateDelta;
		if (timeStamp > singleFrameTime) {
			render.render(scene, camera)

			//渲染
			// 剩余的时间合并进入下次的判断计算 这里使用取余数是因为 当页页面失去焦点又重新获得焦点的时候，delta数值会非常大， 这个时候就需要
			timeStamp = (timeStamp % singleFrameTime);
		}

		requestAnimationFrame(renderFrame)

	}


	function createGuideShopman(positionX = 0, positionZ = 0, action = "waving") {


		loadFbxModel("town2/boy21.fbx", {
			scaleY: 2.5,
			castShadow: true,
			loadCallback: (model) => {

				//动作
				const mixer = new THREE.AnimationMixer(model);
				mixerObj[model.uuid] = mixer
				let animations = model.animations;

				//随机上衣和裤子的颜色
				model.traverse(function(object) {
					if (object.name === "Wolf3D_Outfit_Top") {
						object.material = object.material.clone()
						object.material.map = textureMap["outfit-classic-03-v2-m-top-D_W.jpg"]
						// object.material.map.needsUpdate = true
						// object.material.needsUpdate = true
					}

					if (object.name === "Wolf3D_Outfit_Bottom") {
						object.material = object.material.clone()
						object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_W.jpg"]
						// object.material.map.needsUpdate = true
						// object.material.needsUpdate = true

					}

				})
				const allActions = []
				//遍歷所有動作
				for (let i = 0; i !== animations.length; ++i) {
					//動作
					const clip = animations[i];
					const action = mixer.clipAction(clip);
					allActions[clip.name] = action;
				}
				// console.log(animations)
				allActions[action].play();

				//注册动作播放方法
				funcListObj['updateMixerByTime'] = updateMixerByTime
			},
			callback: (group) => {
				// console.log(group)

				scene.add(group)

				group.position.set(73, 0, -35);
				group.rotation.y = -Math.PI / 24;
				
				titleViewVisible.value = false;
			}
		})


	}

	function getEmptyWithAIObj() {
		const withAIObj = {
			group: null,
			model: null,
			allActions: null,
			activeAction: null,
			previousAction: null,
			nextTargetPosition: null, //Vector3
			previousTargetPosition: null,
			targetPositionList: [],
			AI: null,
			action: null,
			name: "",
			memMale: 0,
			targetIndex: 0,
			timer_1: 0,
			timer_2: 0
		}

		return withAIObj
	}
</script>

<style  scoped>
	.title-view {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		/*background: #6a84b3;*/
		color: #2c3e50;
		z-index: 22;
		transition: all 1.5s ease;
	}

	body {
		margin: 0;
	}

	.loading-background {
		background: #6a84b3;
	}

	.loading-background-complete {
		background: #ffffff00;
	}

	.loading-num-part {
		width: 4em;
		height: 4em;
		border-radius: 50%;
		background: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: auto;
		transition: all 1.5s ease;
		;
	}

	.shoppee_text_3 {
		font-size: 1.8em;
		font-family: impact, arial;
		color: #17a5ff;
		text-shadow: 0px 0px 0 #007ecf, 1px -1px 0 #007bca, 2px -2px 0 #0075bf, 3px -3px 0 #006fb5, 4px -4px 0 #0069ab, 5px -5px 0 #0062a1, 6px -6px 0 #005c97, 7px -7px 6px rgba(0, 0, 0, 0.55), 7px -7px 1px rgba(0, 0, 0, 0.5);
	}

	.shoppee_text_D {
		font-size: 1.8em;
		padding-right: 8px;
		font-family: impact, arial;
		color: #b20bff;
		text-shadow: 0px 0px 0 #8500c3, 1px -1px 0 #7e00b8, 2px -2px 0 #7700ae, 3px -3px 0 #7000a4, 4px -4px 0 #69009a, 5px -5px 0 #620090, 6px -6px 0 #5b0085, 7px -7px 6px rgba(0, 0, 0, 0.55), 7px -7px 1px rgba(0, 0, 0, 0.5);
	}

	.num-part-uncomplete {
		margin-top: 4em;
	}

	.num-part-complete {
		margin-top: 8em;
	}

	.btn_start_div:hover {
		border-radius: 50%;
		background-color: #ffffff
	}

	/* 设置发光 */
	
	.btn_start {
		content: "";
		left: -5px;
		right: -5px;
		top: -5px;
		bottom: -5px;
		position: absolute;
		color: coral;
		background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
		background-size: 400%;
		border-radius: 50px;
		filter: blur(20px);
		z-index: -1;
		animation: btn_start_sun 8s infinite;
	}

	/* 设置流光 */
	@keyframes btn_start_sun {
		100% {
			background-position: -400% 0;
		}
	}

	.loading_ring {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 5em;
		height: 5em;
		background: transparent;
		border: 3px solid #b20bff;
		border-radius: 50%;
		text-align: center;
		line-height: 5em;
		font-family: sans-serif;
		font-size: 20px;
		color: #03a9f4;
		letter-spacing: 4px;
		text-transform: uppercase;
		text-shadow: 0 0 10px #03a9f4;
		box-shadow: 0 0 20px rgba(0, 0, 0, .5);
	}

	.loading_ring:before {
		content: '';
		position: absolute;
		top: -3px;
		left: -3px;
		width: 100%;
		height: 100%;
		border: 3px solid transparent;
		border-top: 3px solid #03a9f4;
		border-right: 3px solid #03a9f4;
		border-radius: 50%;
		animation: animateC 2s linear infinite;
	}

	.loading_ring_span {
		display: block;
		position: absolute;
		top: calc(50% - 2px);
		left: 50%;
		width: 50%;
		height: 4px;
		background: transparent;
		transform-origin: left;
		animation: animate 2s linear infinite;
	}

	.loading_ring_span:before {
		content: '';
		position: absolute;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: #03a9f4;
		top: -6px;
		right: -8px;
		box-shadow: 0 0 20px #03a9f4;
	}


	@keyframes animateC {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes animate {
		0% {
			transform: rotate(45deg);
		}

		100% {
			transform: rotate(405deg);
		}
	}

	@media screen and (min-width: 520px) {
		.my-msg-box {
			position: fixed;
			width: 500px;
			height: 150px;
			background: #ffffff;
			left: calc(50vw - 250px);
			top: 215px;
			z-index: 300;
			border-radius: 20px;
			border: #ddd 1px solid;
			font-size: 18px;
			color: #4e486d;
			font-weight: 800;
			text-align: left;
			cursor: default;
			user-select: none;

		}
	}

	@media screen and (max-width: 520px) {
		.my-msg-box {
			position: fixed;
			width: 80%;
			min-height: 150px;
			background: #ffffff;
			left: 10%;
			top: 35%;
			z-index: 300;
			border-radius: 20px;
			border: #ddd 1px solid;
			font-size: 18px;
			color: #4e486d;
			font-weight: 800;
			text-align: left;
			cursor: default;
			user-select: none;

		}
	}

	.my-msg-box .msg-box {
		padding-left: 0;
		margin: auto;
		margin-top: 10px;
		width: 90%;
		height: calc(100% - 20px);
		list-style: none;
	}

	.my-msg-box .title-box {
		text-align: left;
		height: 30px;
		color: #438ae5;
		list-style: none;
	}

	.my-msg-box .content-box {
		height: calc(100% - 60px);
		list-style: none;
	}

	.my-msg-box .msg-box .operation-box {
		text-align: right;
		font-size: 20px;
		height: 30px;
		list-style: none;
	}
</style>